import {createSlice} from "@reduxjs/toolkit";
import {initialAdminState, initialState} from "./initState";
import {FAILED, IDLE, LOADING, SUCCESS} from "../../common/statuses";
import {
    acceptRecoveryPassword,
    AUTH,
    getNextLesson,
    isAuthenticated,
    login,
    logout, recoveryPassword,
    sendImage,
    updateUser,
    updateUserAdditional
} from "./authService";
import {
    changeBalance,
    getCountOfUnique,
    getCountOfUniqueHost,
    getCourses,
    getStudents,
    getTeachers,
    saveTeacher
} from "./authAdminService";
import {errorConverterFields} from "../../common/formater";
import {ROLE_ADMIN} from "../../common/roles";


const authSlice = createSlice({
    name: AUTH,
    initialState,
    reducers: {
        removeLesson: (state) => {
            delete state.current.lesson
        },
        clearAuth: (state) => {
            state = initialState;
        },
        clearUpdateUser: ({updateUser}) => {
            updateUser = initialState.updateUser;
        },
        clearStatistic: (state) => {
            delete state.statistic
            state.statistic = initialAdminState.statistic
}
    },
    extraReducers(builder) {
        builder
            .addCase(login.pending, (state) => {
                state.status = LOADING
            })
            .addCase(login.fulfilled, (state, action) => {
                state.status = SUCCESS
                localStorage.removeItem("accessToken")
                localStorage.setItem("accessToken", action.payload.accessToken);
            })
            .addCase(login.rejected, (state) => {
                state.status = FAILED
            })

            .addCase(logout.fulfilled, (state) => {
                localStorage.removeItem("accessToken")
                state.status = IDLE;
                state.error = null;
                state.current = undefined;
                delete state.teacher;
                delete state.courses;
            })
            .addCase(logout.rejected, (state) => {
                state.status = FAILED
            })

            .addCase(recoveryPassword.pending, (state) => {
                state.retrievalStatus = LOADING
            })
            .addCase(recoveryPassword.fulfilled, (state) => {
                state.retrievalStatus = SUCCESS
            })
            .addCase(recoveryPassword.rejected, (state) => {
                state.retrievalStatus = FAILED
            })

            .addCase(acceptRecoveryPassword.pending, (state) => {
                state.recovery = {
                    status: LOADING
                }
            })
            .addCase(acceptRecoveryPassword.fulfilled, (state, {payload}) => {
                state.recovery = {
                    status: SUCCESS,
                    response: payload
                }
            })
            .addCase(acceptRecoveryPassword.rejected, (state) => {
                state.recovery = {
                    status: FAILED
                }
            })

            // isAuthenticated
            .addCase(isAuthenticated.fulfilled, (state, action) => {
                const init = action.payload.role === ROLE_ADMIN ? initialAdminState : initialState;
                return {
                    ...init,
                    status: SUCCESS,
                    current: action.payload,

                }
            })
            .addCase(isAuthenticated.rejected, () => {
                return {
                    ...initialState,
                    status: FAILED
                }
            })

            .addCase(getNextLesson.fulfilled, (state, action) => {
                state.current = {
                    ...state.current,
                    lesson: action.payload
                }
            })
            .addCase(getNextLesson.rejected, ({current}) => {
                delete current.lesson
            })

            .addCase(sendImage.fulfilled, (state, action) => {
                state.current = {
                    ...state.current,
                    img: action.payload
                }
            })

            .addCase(updateUser.pending, ({updateUser}) => {
                updateUser.status = LOADING;
            })
            .addCase(updateUser.fulfilled, (state, {payload}) => {
                state.updateUser.status = SUCCESS;
                state.current = {...state.current, ...payload}
            })
            .addCase(updateUser.rejected, ({updateUser}, action) => {
                updateUser.status = FAILED;
                updateUser.errors = errorConverterFields(action);
            })

            .addCase(updateUserAdditional.pending, ({updateUser}) => {
                updateUser.status = LOADING;
            })
            .addCase(updateUserAdditional.fulfilled, (state, {payload}) => {
                state.updateUser.status = SUCCESS;
                state.current = {...state.current, ...payload}
            })
            .addCase(updateUserAdditional.rejected, ({updateUser}, action) => {
                updateUser.status = FAILED;
                updateUser.errors = errorConverterFields(action);
            })


            // Admin cases

            .addCase(getCourses.pending, ({courses}) => {
                courses.status = LOADING
            })
            .addCase(getCourses.fulfilled, ({courses}, action) => {
                courses.status = SUCCESS;
                courses.list = action.payload;
            })
            .addCase(getCourses.rejected, ({courses}) => {
                courses.status = FAILED;
            })

            .addCase(saveTeacher.pending, ({teacher}) => {
                teacher.saveStatus = LOADING
            })
            .addCase(saveTeacher.fulfilled, ({teacher}) => {
                teacher.saveStatus = SUCCESS;
            })
            .addCase(saveTeacher.rejected, ({teacher}, action) => {
                teacher.error = errorConverterFields(action.payload);
                teacher.saveStatus = FAILED;
            })

            .addCase(getTeachers.pending, ({getTeachers}) => {
                getTeachers.status = LOADING
            })
            .addCase(getTeachers.fulfilled, ({getTeachers}, action) => {
                getTeachers.status = SUCCESS;
                getTeachers.data = action.payload
            })
            .addCase(getTeachers.rejected, ({getTeachers}) => {
                getTeachers.status = FAILED;
            })

            .addCase(getStudents.pending, ({getStudents}) => {
                getStudents.status = LOADING
            })
            .addCase(getStudents.fulfilled, ({getStudents}, action) => {
                getStudents.status = SUCCESS;
                getStudents.data = action.payload
            })
            .addCase(getStudents.rejected, ({getStudents}) => {
                getStudents.status = FAILED;
            })

            .addCase(changeBalance.pending, ({student}) => {
                student.changeBalanceStatus = LOADING
            })
            .addCase(changeBalance.fulfilled, ({student}) => {
                student.changeBalanceStatus = SUCCESS;
            })
            .addCase(changeBalance.rejected, ({student}, action) => {
                student.changeBalanceStatus = FAILED;
                student.error = errorConverterFields(action);
            })

            .addCase(getCountOfUnique.pending, ({statistic}) => {
                statistic.status = LOADING
            })
            .addCase(getCountOfUnique.fulfilled, ({statistic}, {payload}) => {
                statistic.status = SUCCESS;
                statistic.data = payload
            })
            .addCase(getCountOfUnique.rejected, ({statistic}) => {
                statistic.status = FAILED;
            })

            .addCase(getCountOfUniqueHost.pending, ({statistic}) => {
                statistic.status = LOADING
            })
            .addCase(getCountOfUniqueHost.fulfilled, ({statistic}, {payload}) => {
                statistic.status = SUCCESS;
                statistic.data = payload
            })
            .addCase(getCountOfUniqueHost.rejected, ({statistic}) => {
                statistic.status = FAILED;
            })

    }
})

export const {removeLesson, clearAuth, clearUpdateUser, clearStatistic} = authSlice.actions
export default authSlice.reducer